import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dialogContainer: { borderRadius: '10px' },
  dialogContent: {
    height: '100%',
  },
}));
